import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // 可根据需要添加初始状态
    },
    mutations: {
        // 可根据需要添加 mutation
    },
    actions: {
        // 可根据需要添加 action
    },
    modules: {
        // 可根据需要添加模块
    }
})
